import type Lenis from 'lenis';

let instance: Lenis | null = null;

export const setLenis = (l: Lenis | null) => {
  instance = l;
};

export const getLenis = () => instance;

/** Instant jump that stays in sync with smooth scrolling when it is active. */
export const jumpTo = (y: number) => {
  if (instance) instance.scrollTo(y, { immediate: true, force: true });
  else window.scrollTo(0, y);
};

/** Smooth scroll to an element (falls back to native behaviour). */
export const scrollToEl = (el: HTMLElement | null, smooth = true) => {
  if (!el) return;
  if (instance) instance.scrollTo(el, { immediate: !smooth, force: true });
  else el.scrollIntoView(smooth ? { behavior: 'smooth' } : undefined);
};

export const pauseScroll = () => instance?.stop();
export const resumeScroll = () => instance?.start();